// src/app/app.initializers.ts
import { ConfigService } from './services/config.service';
import { Observable } from 'rxjs';

export const configFactory = (config: ConfigService): (() => Observable<boolean>) => {
  return () => config.loadCompanyConfig();
};